import React, { useState } from 'react';
import { Container, Typography, TextField, Button, MenuItem, Select, InputLabel, FormControl, Alert } from '@mui/material';
import AdminNavbar from './AdminNavbar';
import axios from 'axios';
import menuService from '../services/menuService';

const MenuMaintenance = () => {
    const [menuItemId, setMenuItemId] = useState(null); // Track the ID of the item being edited
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState(null);
    const [category, setCategory] = useState('');
    const [price, setPrice] = useState('');
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState('');

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
    };

    const fetchMenuItem = async (id) => {
        try {
            const response = await axios.get(`/api/menu/${id}`);
            const item = response.data;
            setMenuItemId(item.id);
            setName(item.name);
            setDescription(item.description);
            setCategory(item.category);
            setPrice(item.price);
            setImage(null); // Reset the image field
        } catch (error) {
            console.error('Error fetching menu item:', error);
            setMessage('Error fetching menu item. Please try again.');
            setMessageType('error');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const formData = new FormData();
        formData.append('name', name);
        formData.append('description', description);
        formData.append('category', category);
        formData.append('price', price);
        if (image) {
            formData.append('image', image);
        }
    
        try {
            if (menuItemId) {
                // Use menuService to update a menu item
                await menuService.updateMenuItem(menuItemId, formData);
                setMessage('Menu item updated successfully!');
            } else {
                // Use menuService to add a new menu item
                await menuService.addMenuItem(formData);
                setMessage('Menu item added successfully!');
            }
            setMessageType('success');
            setMenuItemId(null);
            setName('');
            setDescription('');
            setCategory('');
            setPrice('');
            setImage(null);
        } catch (error) {
            setMessage(menuItemId ? 'Error updating menu item. Please try again.' : 'Error adding menu item. Please try again.');
            setMessageType('error');
            console.error('Error submitting menu item:', error);
        }
    };

    return (
        <>
            <AdminNavbar onLogout={handleLogout} />
            <Container>
                <Typography variant="h4" gutterBottom>
                    {menuItemId ? 'Edit Menu Item' : 'Add Menu Item'}
                </Typography>
                {message && (
                    <Alert severity={messageType} sx={{ marginBottom: '20px' }}>
                        {message}
                    </Alert>
                )}
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <TextField
                        label="Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <TextField
                        label="Price"
                        type="number"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        fullWidth
                        required
                        margin="normal"
                        inputProps={{ min: 0, step: 0.01 }}
                    />
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Category</InputLabel>
                        <Select
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            required
                        >
                            <MenuItem value="brunch">Brunch</MenuItem>
                            <MenuItem value="lunch">Lunch</MenuItem>
                            <MenuItem value="dinner">Dinner</MenuItem>
                            <MenuItem value="drinks">Drinks</MenuItem>
                        </Select>
                    </FormControl>
                    <Button
                        variant="contained"
                        component="label"
                        sx={{ marginTop: '20px' }}
                    >
                        Upload Image
                        <input
                            type="file"
                            hidden
                            onChange={(e) => setImage(e.target.files[0])}
                        />
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ marginTop: '20px', marginLeft: '10px' }}
                    >
                        Submit
                    </Button>
                </form>
            </Container>
        </>
    );
};

export default MenuMaintenance;